
import { axios } from "../axios.instance";

export type AccountResetPasswordRequest = {
  code: string;
  newPassword: string;
};

export type AccountResetPasswordResponse = object;

export const accountResetPassword = async (body: AccountResetPasswordRequest): Promise<AccountResetPasswordResponse> => {
  const { data } = await axios.post("auth/account/reset-password", body);

  return data;
};
